/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as WWorkspaceIdRouteImport } from "./routes/w.$workspaceId"
import { Route as WWorkspaceIdIndexRouteImport } from "./routes/w.$workspaceId/index"
import { Route as WWorkspaceIdAuditRouteImport } from "./routes/w.$workspaceId/audit"
import { Route as WWorkspaceIdLocationsIndexRouteImport } from "./routes/w.$workspaceId/locations.index"
import { Route as WWorkspaceIdLocationsLocationIdRouteImport } from "./routes/w.$workspaceId/locations.$locationId"
import { Route as WWorkspaceIdLocationsNewRouteImport } from "./routes/w.$workspaceId/locations.new"
import { Route as WWorkspaceIdScreensIndexRouteImport } from "./routes/w.$workspaceId/screens.index"
import { Route as WWorkspaceIdScreensScreenIdRouteImport } from "./routes/w.$workspaceId/screens.$screenId"
import { Route as WWorkspaceIdScreensNewRouteImport } from "./routes/w.$workspaceId/screens.new"
import { Route as WWorkspaceIdTemplatesIndexRouteImport } from "./routes/w.$workspaceId/templates.index"
import { Route as WWorkspaceIdTemplatesTemplateIdRouteImport } from "./routes/w.$workspaceId/templates.$templateId"
import { Route as WWorkspaceIdTemplatesNewRouteImport } from "./routes/w.$workspaceId/templates.new"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdRoute = WWorkspaceIdRouteImport.update({
  id: "/w/$workspaceId",
  path: "/w/$workspaceId",
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdIndexRoute = WWorkspaceIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdAuditRoute = WWorkspaceIdAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdLocationsIndexRoute =
  WWorkspaceIdLocationsIndexRouteImport.update({
    id: "/locations/",
    path: "/locations/",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdLocationsLocationIdRoute =
  WWorkspaceIdLocationsLocationIdRouteImport.update({
    id: "/locations/$locationId",
    path: "/locations/$locationId",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdLocationsNewRoute =
  WWorkspaceIdLocationsNewRouteImport.update({
    id: "/locations/new",
    path: "/locations/new",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdScreensIndexRoute =
  WWorkspaceIdScreensIndexRouteImport.update({
    id: "/screens/",
    path: "/screens/",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdScreensScreenIdRoute =
  WWorkspaceIdScreensScreenIdRouteImport.update({
    id: "/screens/$screenId",
    path: "/screens/$screenId",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdScreensNewRoute = WWorkspaceIdScreensNewRouteImport.update({
  id: "/screens/new",
  path: "/screens/new",
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdTemplatesIndexRoute =
  WWorkspaceIdTemplatesIndexRouteImport.update({
    id: "/templates/",
    path: "/templates/",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdTemplatesTemplateIdRoute =
  WWorkspaceIdTemplatesTemplateIdRouteImport.update({
    id: "/templates/$templateId",
    path: "/templates/$templateId",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdTemplatesNewRoute =
  WWorkspaceIdTemplatesNewRouteImport.update({
    id: "/templates/new",
    path: "/templates/new",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/w/$workspaceId": typeof WWorkspaceIdRouteWithChildren
  "/w/$workspaceId/audit": typeof WWorkspaceIdAuditRoute
  "/w/$workspaceId/": typeof WWorkspaceIdIndexRoute
  "/w/$workspaceId/locations/$locationId": typeof WWorkspaceIdLocationsLocationIdRoute
  "/w/$workspaceId/locations/new": typeof WWorkspaceIdLocationsNewRoute
  "/w/$workspaceId/screens/$screenId": typeof WWorkspaceIdScreensScreenIdRoute
  "/w/$workspaceId/screens/new": typeof WWorkspaceIdScreensNewRoute
  "/w/$workspaceId/templates/$templateId": typeof WWorkspaceIdTemplatesTemplateIdRoute
  "/w/$workspaceId/templates/new": typeof WWorkspaceIdTemplatesNewRoute
  "/w/$workspaceId/locations/": typeof WWorkspaceIdLocationsIndexRoute
  "/w/$workspaceId/screens/": typeof WWorkspaceIdScreensIndexRoute
  "/w/$workspaceId/templates/": typeof WWorkspaceIdTemplatesIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/w/$workspaceId/audit": typeof WWorkspaceIdAuditRoute
  "/w/$workspaceId": typeof WWorkspaceIdIndexRoute
  "/w/$workspaceId/locations/$locationId": typeof WWorkspaceIdLocationsLocationIdRoute
  "/w/$workspaceId/locations/new": typeof WWorkspaceIdLocationsNewRoute
  "/w/$workspaceId/screens/$screenId": typeof WWorkspaceIdScreensScreenIdRoute
  "/w/$workspaceId/screens/new": typeof WWorkspaceIdScreensNewRoute
  "/w/$workspaceId/templates/$templateId": typeof WWorkspaceIdTemplatesTemplateIdRoute
  "/w/$workspaceId/templates/new": typeof WWorkspaceIdTemplatesNewRoute
  "/w/$workspaceId/locations": typeof WWorkspaceIdLocationsIndexRoute
  "/w/$workspaceId/screens": typeof WWorkspaceIdScreensIndexRoute
  "/w/$workspaceId/templates": typeof WWorkspaceIdTemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/w/$workspaceId": typeof WWorkspaceIdRouteWithChildren
  "/w/$workspaceId/audit": typeof WWorkspaceIdAuditRoute
  "/w/$workspaceId/": typeof WWorkspaceIdIndexRoute
  "/w/$workspaceId/locations/$locationId": typeof WWorkspaceIdLocationsLocationIdRoute
  "/w/$workspaceId/locations/new": typeof WWorkspaceIdLocationsNewRoute
  "/w/$workspaceId/screens/$screenId": typeof WWorkspaceIdScreensScreenIdRoute
  "/w/$workspaceId/screens/new": typeof WWorkspaceIdScreensNewRoute
  "/w/$workspaceId/templates/$templateId": typeof WWorkspaceIdTemplatesTemplateIdRoute
  "/w/$workspaceId/templates/new": typeof WWorkspaceIdTemplatesNewRoute
  "/w/$workspaceId/locations/": typeof WWorkspaceIdLocationsIndexRoute
  "/w/$workspaceId/screens/": typeof WWorkspaceIdScreensIndexRoute
  "/w/$workspaceId/templates/": typeof WWorkspaceIdTemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/w/$workspaceId"
    | "/w/$workspaceId/audit"
    | "/w/$workspaceId/"
    | "/w/$workspaceId/locations/$locationId"
    | "/w/$workspaceId/locations/new"
    | "/w/$workspaceId/screens/$screenId"
    | "/w/$workspaceId/screens/new"
    | "/w/$workspaceId/templates/$templateId"
    | "/w/$workspaceId/templates/new"
    | "/w/$workspaceId/locations/"
    | "/w/$workspaceId/screens/"
    | "/w/$workspaceId/templates/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/w/$workspaceId/audit"
    | "/w/$workspaceId"
    | "/w/$workspaceId/locations/$locationId"
    | "/w/$workspaceId/locations/new"
    | "/w/$workspaceId/screens/$screenId"
    | "/w/$workspaceId/screens/new"
    | "/w/$workspaceId/templates/$templateId"
    | "/w/$workspaceId/templates/new"
    | "/w/$workspaceId/locations"
    | "/w/$workspaceId/screens"
    | "/w/$workspaceId/templates"
  id:
    | "__root__"
    | "/"
    | "/w/$workspaceId"
    | "/w/$workspaceId/audit"
    | "/w/$workspaceId/"
    | "/w/$workspaceId/locations/$locationId"
    | "/w/$workspaceId/locations/new"
    | "/w/$workspaceId/screens/$screenId"
    | "/w/$workspaceId/screens/new"
    | "/w/$workspaceId/templates/$templateId"
    | "/w/$workspaceId/templates/new"
    | "/w/$workspaceId/locations/"
    | "/w/$workspaceId/screens/"
    | "/w/$workspaceId/templates/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WWorkspaceIdRoute: typeof WWorkspaceIdRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/w/$workspaceId": {
      id: "/w/$workspaceId"
      path: "/w/$workspaceId"
      fullPath: "/w/$workspaceId"
      preLoaderRoute: typeof WWorkspaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/w/$workspaceId/": {
      id: "/w/$workspaceId/"
      path: "/"
      fullPath: "/w/$workspaceId/"
      preLoaderRoute: typeof WWorkspaceIdIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/audit": {
      id: "/w/$workspaceId/audit"
      path: "/audit"
      fullPath: "/w/$workspaceId/audit"
      preLoaderRoute: typeof WWorkspaceIdAuditRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/locations/": {
      id: "/w/$workspaceId/locations/"
      path: "/locations"
      fullPath: "/w/$workspaceId/locations/"
      preLoaderRoute: typeof WWorkspaceIdLocationsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/locations/$locationId": {
      id: "/w/$workspaceId/locations/$locationId"
      path: "/locations/$locationId"
      fullPath: "/w/$workspaceId/locations/$locationId"
      preLoaderRoute: typeof WWorkspaceIdLocationsLocationIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/locations/new": {
      id: "/w/$workspaceId/locations/new"
      path: "/locations/new"
      fullPath: "/w/$workspaceId/locations/new"
      preLoaderRoute: typeof WWorkspaceIdLocationsNewRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/screens/": {
      id: "/w/$workspaceId/screens/"
      path: "/screens"
      fullPath: "/w/$workspaceId/screens/"
      preLoaderRoute: typeof WWorkspaceIdScreensIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/screens/$screenId": {
      id: "/w/$workspaceId/screens/$screenId"
      path: "/screens/$screenId"
      fullPath: "/w/$workspaceId/screens/$screenId"
      preLoaderRoute: typeof WWorkspaceIdScreensScreenIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/screens/new": {
      id: "/w/$workspaceId/screens/new"
      path: "/screens/new"
      fullPath: "/w/$workspaceId/screens/new"
      preLoaderRoute: typeof WWorkspaceIdScreensNewRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/templates/": {
      id: "/w/$workspaceId/templates/"
      path: "/templates"
      fullPath: "/w/$workspaceId/templates/"
      preLoaderRoute: typeof WWorkspaceIdTemplatesIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/templates/$templateId": {
      id: "/w/$workspaceId/templates/$templateId"
      path: "/templates/$templateId"
      fullPath: "/w/$workspaceId/templates/$templateId"
      preLoaderRoute: typeof WWorkspaceIdTemplatesTemplateIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/templates/new": {
      id: "/w/$workspaceId/templates/new"
      path: "/templates/new"
      fullPath: "/w/$workspaceId/templates/new"
      preLoaderRoute: typeof WWorkspaceIdTemplatesNewRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
  }
}

interface WWorkspaceIdRouteChildren {
  WWorkspaceIdAuditRoute: typeof WWorkspaceIdAuditRoute
  WWorkspaceIdIndexRoute: typeof WWorkspaceIdIndexRoute
  WWorkspaceIdLocationsLocationIdRoute: typeof WWorkspaceIdLocationsLocationIdRoute
  WWorkspaceIdLocationsNewRoute: typeof WWorkspaceIdLocationsNewRoute
  WWorkspaceIdScreensScreenIdRoute: typeof WWorkspaceIdScreensScreenIdRoute
  WWorkspaceIdScreensNewRoute: typeof WWorkspaceIdScreensNewRoute
  WWorkspaceIdTemplatesTemplateIdRoute: typeof WWorkspaceIdTemplatesTemplateIdRoute
  WWorkspaceIdTemplatesNewRoute: typeof WWorkspaceIdTemplatesNewRoute
  WWorkspaceIdLocationsIndexRoute: typeof WWorkspaceIdLocationsIndexRoute
  WWorkspaceIdScreensIndexRoute: typeof WWorkspaceIdScreensIndexRoute
  WWorkspaceIdTemplatesIndexRoute: typeof WWorkspaceIdTemplatesIndexRoute
}

const WWorkspaceIdRouteChildren: WWorkspaceIdRouteChildren = {
  WWorkspaceIdAuditRoute: WWorkspaceIdAuditRoute,
  WWorkspaceIdIndexRoute: WWorkspaceIdIndexRoute,
  WWorkspaceIdLocationsLocationIdRoute: WWorkspaceIdLocationsLocationIdRoute,
  WWorkspaceIdLocationsNewRoute: WWorkspaceIdLocationsNewRoute,
  WWorkspaceIdScreensScreenIdRoute: WWorkspaceIdScreensScreenIdRoute,
  WWorkspaceIdScreensNewRoute: WWorkspaceIdScreensNewRoute,
  WWorkspaceIdTemplatesTemplateIdRoute: WWorkspaceIdTemplatesTemplateIdRoute,
  WWorkspaceIdTemplatesNewRoute: WWorkspaceIdTemplatesNewRoute,
  WWorkspaceIdLocationsIndexRoute: WWorkspaceIdLocationsIndexRoute,
  WWorkspaceIdScreensIndexRoute: WWorkspaceIdScreensIndexRoute,
  WWorkspaceIdTemplatesIndexRoute: WWorkspaceIdTemplatesIndexRoute,
}

const WWorkspaceIdRouteWithChildren = WWorkspaceIdRoute._addFileChildren(
  WWorkspaceIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WWorkspaceIdRoute: WWorkspaceIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
